(() => {
  const DEBUG = false;

  function getSectionIdsFromInventoryEls() {
    return Array.from(document.querySelectorAll('[id^="Inventory-"]')).map((el) =>
      el.id.slice('Inventory-'.length)
    );
  }

  function getProductUrlForSection(sectionId) {
    // main-product.liquid: <product-info data-url="..." data-section="...">
    const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
    return productInfo?.dataset?.url || window.location.pathname;
  }

  function getSelectedOptionValueIds(sectionId) {
    const variantSelects = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
    if (!variantSelects) return [];

    return Array.from(variantSelects.querySelectorAll('select option[selected], fieldset input:checked'))
      .map((el) => el?.dataset?.optionValueId)
      .filter(Boolean);
  }

  function signatureFromOptionValueIds(optionValueIds) {
    return optionValueIds.join(',');
  }

  function updateInventorySection(sectionId, optionValueIds) {
    const inventoryEl = document.getElementById(`Inventory-${sectionId}`);
    if (!inventoryEl) return;
    if (!optionValueIds?.length) return;

    const productUrl = getProductUrlForSection(sectionId);
    const requestUrl = `${productUrl}${productUrl.includes('?') ? '&' : '?'}section_id=${encodeURIComponent(
      sectionId
    )}&option_values=${encodeURIComponent(optionValueIds.join(','))}`;

    if (DEBUG) {
      const beforeAvailability = inventoryEl.querySelector('.ec-availability');
      console.log('[ec-availability-status] updateInventorySection fetch', {
        sectionId,
        requestUrl,
        optionValues: optionValueIds,
        beforeEcAvailabilityExists: !!beforeAvailability,
        beforeText: beforeAvailability?.querySelector('.ec-availability__text')?.textContent?.trim?.() || '',
        beforeClass: beforeAvailability?.className || '',
      });
    }

    fetch(requestUrl)
      .then((r) => r.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const sourceInventory = html.getElementById(`Inventory-${sectionId}`);
        if (!sourceInventory) return;

        const srcAvailability = sourceInventory.querySelector('.ec-availability');
        if (DEBUG) {
          console.log('[ec-availability-status] updateInventorySection response parsed', {
            sectionId,
            sourceHasEcAvailability: !!srcAvailability,
            sourceText: srcAvailability?.querySelector('.ec-availability__text')?.textContent?.trim?.() || '',
            sourceClass: srcAvailability?.className || '',
            sourceInventoryInnerHtmlPreview: (sourceInventory.innerHTML || '').slice(0, 200),
          });
        }

        inventoryEl.innerHTML = sourceInventory.innerHTML;

        if (DEBUG) {
          const afterAvailability = inventoryEl.querySelector('.ec-availability');
          console.log('[ec-availability-status] updateInventorySection applied', {
            sectionId,
            afterText: afterAvailability?.querySelector('.ec-availability__text')?.textContent?.trim?.() || '',
            afterClass: afterAvailability?.className || '',
          });
        }
      })
      .catch((e) => {
        if (DEBUG) console.error('[ec-availability-status] fetch inventory error', e);
      });
  }

  function init() {
    const inventorySectionIds = getSectionIdsFromInventoryEls();
    if (!inventorySectionIds.length) return;

    const lastSignatureBySectionId = new Map();
    let scheduled = null;

    const schedule = () => {
      if (scheduled) clearTimeout(scheduled);
      scheduled = setTimeout(() => {
        scheduled = null;
        if (DEBUG) console.log('[ec-availability-status] schedule tick');

        inventorySectionIds.forEach((sectionId) => {
          const optionValueIds = getSelectedOptionValueIds(sectionId);
          const signature = signatureFromOptionValueIds(optionValueIds);
          if (!signature) return;

          const lastSignature = lastSignatureBySectionId.get(sectionId) || null;
          if (lastSignature === signature) {
            if (DEBUG) console.log('[ec-availability-status] schedule no change', { sectionId, signature });
            return;
          }

          lastSignatureBySectionId.set(sectionId, signature);
          if (DEBUG) console.log('[ec-availability-status] schedule will update', { sectionId, signature });
          updateInventorySection(sectionId, optionValueIds);
        });
      }, 120);
    };

    // Um único observer global para capturar qualquer troca de variante (swap de HTML do product-info).
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { subtree: true, childList: true, attributes: true });

    if (DEBUG) console.log('[ec-availability-status] init observers inventorySectionIds:', inventorySectionIds);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
